export default __webpack_public_path__ + "2019b91.png";